import {FC, useContext, useRef} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {toast} from 'react-toastify';
import {useRecoilValue, useSetRecoilState} from 'recoil';

import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import {Button, Stack, Typography} from '@mui/material';

import {EventBusContext} from '../../../../providers/EventBus';

import {currentDeviceModelState, deviceModelsQueryTrigger} from '../../../../store/deviceModels/atoms';

import {DictionaryService} from '../../../../api/services/dictionary.service';

import {IDeviceModel} from '../../../../shared/types/deviceModels.types';
import {IDeviceTypesDict} from '../../../../shared/types/deviceTypesDict.types';
import {DeviceModelFields} from './DeviceModelFields';

interface IEditDeviceModel {
  handleClose: () => void;
  setLoading: (arg: boolean) => void;
  loading: boolean;
  deviceTypes: IDeviceTypesDict[];
}

export const EditDeviceModel: FC<IEditDeviceModel> = ({handleClose, setLoading, loading, deviceTypes}) => {
  const deviceModel = useRecoilValue(currentDeviceModelState) as IDeviceModel;
  const {
    control,
    handleSubmit,
    formState: {isDirty},
  } = useForm<IDeviceModel>({
    mode: 'onChange',
    defaultValues: deviceModel,
  });
  const triggerDeviceModelsQuery = useSetRecoilState(deviceModelsQueryTrigger);
  const ref = useRef<HTMLFormElement | null>(null);
  const {bus} = useContext(EventBusContext);

  const onSubmit: SubmitHandler<IDeviceModel> = async (data) => {
    try {
      setLoading(true);

      await DictionaryService.updateDeviceModel({
        ...data,
        model: data.model.trim(),
      });

      toast.success('Данные изменены', {
        containerId: 'default',
        autoClose: 2000,
        hideProgressBar: true,
        pauseOnHover: false,
        draggable: false,
      });

      triggerDeviceModelsQuery((v) => v + 1);

      setTimeout(() => {
        setLoading(false);
        handleClose();
      });
    } catch (err) {
      bus?.emit('error', [err]);
      setLoading(false);
    }
  };

  return (
    <form style={{height: '100%'}} ref={ref} onSubmit={handleSubmit(onSubmit)}>
      <Stack sx={{height: '100%'}} direction="column" justifyContent="space-between">
        <Stack sx={{height: '100%'}} direction="column" spacing={2}>
          <Stack direction="row" sx={{justifyContent: 'flex-start'}}>
            <Typography variant="h5">Редактировать модель устройства</Typography>
          </Stack>
          <DeviceModelFields loading={loading} deviceTypes={deviceTypes} control={control} />
        </Stack>
        <Stack direction="row" sx={{justifyContent: 'space-between', mt: 4}}>
          <LoadingButton
            onClick={() => {
              ref?.current?.requestSubmit();
            }}
            variant="outlined"
            color="success"
            disabled={!isDirty}
            loading={loading}
          >
            Сохранить изменения
          </LoadingButton>
          <Button onClick={handleClose} variant="outlined" color="error" disabled={loading}>
            Отмена
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
